module.exports = __webpack_public_path__ + "assets/images/ae18dd55ad5278d3ba24ad43a023323a.png";